/* Wherly : apparitions au défilement, notifications qui tournent, compteurs. Sans ce script, tout reste visible et lisible. */
(function () {
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function compter(el) {
    var cible = parseFloat(el.getAttribute('data-w-count'));
    var dec = parseInt(el.getAttribute('data-w-dec') || '0', 10);
    var pre = el.textContent.replace(/[0-9.,]+/g, '');
    if (isNaN(cible) || calme) return;
    var t0 = null, duree = 1400;
    function pas(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / duree), v = cible * (1 - Math.pow(1 - k, 3));
      el.textContent = pre + v.toFixed(dec);
      if (k < 1) requestAnimationFrame(pas);
    }
    requestAnimationFrame(pas);
  }

  function tourner(rot) {
    var items = rot.querySelectorAll('.w-notif');
    if (items.length < 2 || calme) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 2800);
  }

  function proche(el) {
    var box = el.closest('.w-finder'), lbl = box && box.querySelector('[data-w-near-lbl]');
    var depart = parseFloat(el.getAttribute('data-from')) || 12, d = depart;
    if (calme) return;
    setInterval(function () {
      d = d > 0.4 ? Math.max(0.3, d * 0.82) : depart;
      el.textContent = d.toFixed(1);
      if (lbl) lbl.textContent = d <= 0.4 ? el.getAttribute('data-found') : (d < 3 ? el.getAttribute('data-near') : el.getAttribute('data-far'));
      if (box) box.classList.toggle('is-found', d <= 0.4);
    }, 650);
  }

  function avatars(box) {
    if (box.dataset.wPret) return; box.dataset.wPret = '1';
    var imgs = box.querySelectorAll('.w-users__img');
    if (calme || imgs.length < 4) return;
    setInterval(function () {
      var first = box.querySelector('.w-users__img'), next = box.children[3];
      if (!first || !next) return;
      first.classList.add('is-out'); next.classList.add('is-next');
      setTimeout(function () {
        first.classList.remove('is-out'); box.appendChild(first);
        next.classList.remove('is-next');
      }, 520);
    }, 2400);
  }

  function carrousel(box) {
    if (box.dataset.wPret) return; box.dataset.wPret = '1';
    var items = box.querySelectorAll('.w-rcar__it'), dots = box.querySelector('.w-rcar__dots'), i = 0, t;
    if (!items.length) return;
    dots.innerHTML = '';
    items.forEach(function (it) { it.classList.remove('is-on', 'is-out'); dots.appendChild(document.createElement('i')); });
    function montrer(n) {
      items[i].classList.remove('is-on'); items[i].classList.add('is-out');
      var ancien = items[i]; setTimeout(function () { ancien.classList.remove('is-out'); }, 500);
      i = (n + items.length) % items.length; items[i].classList.add('is-on');
      dots.querySelectorAll('i').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function lancer() { clearInterval(t); if (!calme && items.length > 1) t = setInterval(function () { montrer(i + 1); }, 4500); }
    items[0].classList.add('is-on'); dots.firstChild.classList.add('is-on');
    box.querySelector('[data-w-prev]').addEventListener('click', function () { montrer(i - 1); lancer(); });
    box.querySelector('[data-w-next]').addEventListener('click', function () { montrer(i + 1); lancer(); });
    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { montrer(i + (dx < 0 ? 1 : -1)); lancer(); } x0 = null; });
    lancer();
  }

  function mosaique(grid) {
    if (grid.dataset.wPret) return; grid.dataset.wPret = '1';
    var cartes = grid.querySelectorAll('.w-rev'), pas = parseInt(grid.getAttribute('data-step'), 10) || 10, vus = pas;
    var bouton = grid.parentNode.querySelector('[data-w-revmore]');
    // Mosaïque équilibrée : chaque avis va dans la colonne la plus courte, pour que les colonnes finissent à la même hauteur.
    var nbCols = 0;
    function ranger(force) {
      var w = grid.clientWidth || window.innerWidth, n = window.innerWidth >= 1100 ? 4 : (window.innerWidth >= 750 ? 3 : 2);
      if (!force && n === nbCols) return; nbCols = n;
      var cols = [];
      grid.querySelectorAll(':scope > .w-rcol').forEach(function (c) { c.remove(); });
      for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'w-rcol'; grid.appendChild(c); cols.push(c); }
      var vis = [], h = [];
      cartes.forEach(function (carte) { if (carte.hidden) cols[n - 1].appendChild(carte); else { cols[0].appendChild(carte); vis.push(carte); } });
      vis.forEach(function (c) { c._wh = c.offsetHeight; });
      vis.sort(function (a, b) { return b._wh - a._wh; });
      cols.forEach(function () { h.push(0); });
      vis.forEach(function (carte) { var k = h.indexOf(Math.min.apply(null, h)); cols[k].appendChild(carte); h[k] += carte._wh; });
    }
    function maj() { cartes.forEach(function (c, k) { c.hidden = k >= vus; }); if (bouton) bouton.hidden = vus >= cartes.length; ranger(true); }
    if (bouton) bouton.addEventListener('click', function () { vus += pas; maj(); });
    window.addEventListener('resize', function () { ranger(false); });
    grid.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', function () { ranger(true); }, { once: true }); });
    maj();
  }

  function demarrer() {
    document.querySelectorAll('[data-w-near]').forEach(proche);
    document.querySelectorAll('[data-w-rotate]').forEach(tourner);
    document.querySelectorAll('[data-w-avatars]').forEach(avatars);
    document.querySelectorAll('[data-w-rcar]').forEach(carrousel);
    document.querySelectorAll('[data-w-revgrid]').forEach(mosaique);
    if (!('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('w-js');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.querySelectorAll('[data-w-count]').forEach(compter);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.w-head, .w-feature__media, .w-showcase__media, .w-gift, .w-promise, .w-map, .w-vs, .w-finder, .w-hero__visual').forEach(function (el) { el.classList.add('w-reveal'); io.observe(el); });
    document.querySelectorAll('.w-vsteps, .w-moments, .w-checks, .w-bento, .w-ugc__track, .w-rev-track, .w-who').forEach(function (el) { el.classList.add('w-reveal-kids'); io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  // Éditeur de thème : un bloc ou une section rechargé(e) reçoit de nouveau ses animations.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-w-rcar]').forEach(carrousel);
    e.target.querySelectorAll('[data-w-revgrid]').forEach(mosaique);
    e.target.querySelectorAll('[data-w-avatars]').forEach(avatars);
  });

  // Barre du bas : « Add to cart » passe par le bouton principal, qui ouvre la fenêtre couleur + système.
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.w-sticky .w-btn');
    if (!s || !/add to cart/i.test(s.textContent)) return;
    var m = document.querySelector('product-form [type="submit"]');
    if (!m) return;
    e.preventDefault(); e.stopImmediatePropagation();
    m.click();
  }, true);
})();

/* Wherly : panier (tiroir) soigné : compteur, barre de livraison gratuite par devise, encart du pack avec sa photo, réassurance. */
(function () {
  var FREE = { USD: 40, GBP: 40, CAD: 60, AUD: 75, NZD: 85 };
  var IMG = {
    1: 'https://cdn.shopify.com/s/files/1/1000/2808/8694/files/wherly-bundle-black-1x.png?v=1793316804&width=240',
    w: 'https://cdn.shopify.com/s/files/1/1000/2808/8694/files/wherly-bundle-white-1x.png?v=1793316811&width=240'
  };
  var css = [
    'cart-drawer .drawer__inner{background:#F6F7F8;padding:0 !important}',
    'cart-drawer .drawer__header{background:#fff;padding:18px 20px 14px !important;border-bottom:1px solid #ECEDEF}',
    'cart-drawer .drawer__heading{font-size:20px !important;font-weight:700}',
    'cart-drawer .wcd-count{display:inline-flex;align-items:center;justify-content:center;min-width:22px;height:22px;border-radius:50px;background:#0C0E13;color:#fff;font-size:12px;font-weight:700;margin-left:8px;vertical-align:middle;padding:0 6px}',
    'cart-drawer .cart-items thead{display:none}',
    'cart-drawer cart-drawer-items{padding:0 14px !important}',
    'cart-drawer .cart-item{display:grid !important;grid-template-columns:76px 1fr auto;column-gap:12px;background:#fff;border-radius:14px;padding:12px !important;margin:10px 0 !important;border:1px solid #ECEDEF}',
    'cart-drawer .cart-item td{padding:0 !important;border:0 !important}',
    'cart-drawer .cart-item__media{grid-row:1/3}',
    'cart-drawer .cart-item__image{border-radius:10px;background:#F3F4F5;width:76px !important;height:76px;object-fit:contain}',
    'cart-drawer .cart-item__name{font-size:15px;font-weight:700;text-decoration:none}',
    'cart-drawer .cart-item__details .product-option{font-size:12.5px;color:#6E6E6E;margin:2px 0}',
    'cart-drawer .cart-item__quantity{grid-column:2/4}',
    'cart-drawer quantity-input.quantity{min-height:36px;width:112px;border-radius:50px}',
    'cart-drawer .quantity:after,cart-drawer .quantity:before{border-radius:50px !important}',
    'cart-drawer .discounts__discount{color:#0F7A4F;font-weight:600}',
    'cart-drawer .drawer__footer{background:#fff;border-top:1px solid #ECEDEF;padding:16px 20px 18px !important}',
    'cart-drawer .totals__total-value{font-size:20px;font-weight:800}',
    'cart-drawer #CartDrawer-Checkout{border-radius:50px;background:#0C0E13;color:#fff;min-height:54px;font-size:16px;font-weight:700;letter-spacing:.01em}',
    'cart-drawer #CartDrawer-Checkout:after{display:none}',
    '.wcd-ship{background:#fff;margin:12px 14px 2px;border:1px solid #ECEDEF;border-radius:14px;padding:12px 14px}',
    '.wcd-ship__txt{font-size:13px;font-weight:600;margin:0 0 8px;display:flex;align-items:center;gap:6px}',
    '.wcd-ship__txt svg{width:16px;height:16px;flex:none}',
    '.wcd-ship.is-done .wcd-ship__txt{color:#0F7A4F}',
    '.wcd-ship__bar{height:6px;border-radius:6px;background:#E6E8EA;overflow:hidden}',
    '.wcd-ship__fill{height:100%;border-radius:6px;background:linear-gradient(90deg,#0F7A4F,#22A86A);transition:width .6s cubic-bezier(.34,1.3,.64,1)}',
    '.wcd-pack{display:flex;align-items:center;gap:12px;background:#E9F5EF;color:#0C0E13;border:1px solid #CFE9DC;margin:10px 14px 0;border-radius:14px;padding:10px 14px}',
    '.wcd-pack img{width:72px;height:54px;object-fit:contain;flex:none}',
    '.wcd-pack b{display:block;font-size:14px}',
    '.wcd-pack span{font-size:12.5px;color:#0F7A4F;font-weight:600}',
    'cart-drawer .wcd-disc{margin-bottom:4px}',
    'cart-drawer .wcd-disc .totals__total,cart-drawer .wcd-disc .totals__total-value{font-size:15px !important;font-weight:600 !important;color:#0F7A4F}',
    'cart-drawer .cart__ctas{display:flex !important;flex-direction:column !important;gap:0 !important}',
    'cart-drawer .wcd-pay{margin-top:10px;width:100%}',
    'cart-drawer .cart-drawer__footer{padding-bottom:14px !important}',
    'cart-drawer .cart-drawer__footer .totals:last-child{margin-bottom:16px !important}','cart-drawer .cart__ctas .w-pay2{display:flex;flex-wrap:wrap;gap:.5rem;justify-content:center;margin-top:12px}','cart-drawer .cart__ctas .w-pay2 .icon{width:2.8rem;height:1.8rem}','cart-drawer .cart__ctas .w-pay2{margin-top:8px !important;gap:.35rem !important}','cart-drawer .drawer__footer{padding:12px 16px calc(10px + env(safe-area-inset-bottom)) !important}','cart-drawer #CartDrawer-Checkout{min-height:50px !important}','cart-drawer .cart-item__image{object-fit:contain !important;background:#fff !important}','cart-drawer .cart-drawer__footer .totals{margin:0 !important;padding:2px 0 !important}',
    'cart-drawer .wcd-pay .shopify-cleanslate ul,cart-drawer .wcd-pay [data-shopify-buttoncontainer]{gap:8px}',
    '.wcd-trust{display:flex;justify-content:space-between;gap:6px;margin-top:12px;font-size:11.5px;color:#6E6E6E}',
    '.wcd-trust span{display:flex;align-items:center;gap:4px}',
    '.wcd-trust svg{width:14px;height:14px;flex:none}'
  ].join('\n');
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 4h14v11H1zM15 8h4l3 3v4h-7"/><circle cx="5.5" cy="18" r="2"/><circle cx="17.5" cy="18" r="2"/></svg>';
  var LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>';
  var RET = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 109-9 9.7 9.7 0 00-6.7 2.8L3 8"/><path d="M3 3v5h5"/></svg>';

  var SYM = { USD: '$', GBP: '£', CAD: 'C$', AUD: 'A$', NZD: 'NZ$', EUR: '€' };
  // Livraison d'1 carte (offerte sur les packs) et économies des paliers, comme sur la page produit.
  var SHIPFEE = { USD: 790, GBP: 499, CAD: 790, AUD: 990, NZD: 990 };
  var PACKSAVE = { 3: { USD: 4690, GBP: 4198, CAD: 6690, AUD: 8189, NZD: 9089 }, 5: { USD: 5601, GBP: 5797, CAD: 8601, AUD: 9797, NZD: 11897 } };
  function money(c, cur) { return (SYM[cur] || '') + (c / 100).toFixed(2) + (SYM[cur] ? '' : ' ' + cur); }
  function fixSym(root, cur) {
    var p = SYM[cur]; if (!p || p === '$' || p.length < 2) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) { var t = n.nodeValue; if (t.indexOf('$') < 0) continue; var v = t.replace(/(^|[^A-Z$])\$(?=\s?\d)/g, function (m, a) { return a + p; }); if (v !== t) n.nodeValue = v; }
  }

  var busy = false;
  function paint() {
    var d = document.querySelector('cart-drawer');
    if (!d || busy) return;
    busy = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var cur = c.currency, inner = d.querySelector('.drawer__inner');
      if (!inner) return;
      var h = d.querySelector('.drawer__heading');
      if (h) {
        var cnt = h.querySelector('.wcd-count');
        if (!cnt) { cnt = document.createElement('span'); cnt.className = 'wcd-count'; h.appendChild(cnt); }
        cnt.textContent = c.item_count; cnt.hidden = !c.item_count;
      }
      var head = d.querySelector('.drawer__header');
      var ship = d.querySelector('.wcd-ship'), pack = d.querySelector('.wcd-pack');
      if (!c.item_count) { if (ship) ship.remove(); if (pack) pack.remove(); return; }
      var lim = FREE[cur];
      if (lim && head) {
        if (!ship) { ship = document.createElement('div'); ship.className = 'wcd-ship'; head.insertAdjacentElement('afterend', ship); }
        var left = lim * 100 - c.total_price, done = left <= 0;
        ship.classList.toggle('is-done', done);
        ship.innerHTML = '<p class="wcd-ship__txt">' + TRUCK + (done ? 'You unlocked FREE tracked shipping' : 'Add ' + money(left, cur) + ' more for FREE tracked shipping') + '</p><div class="wcd-ship__bar"><div class="wcd-ship__fill" style="width:' + Math.min(100, Math.round(c.total_price / (lim * 100) * 100)) + '%"></div></div>';
      } else if (ship) ship.remove();
      var saved = c.original_total_price - c.total_price + (c.cart_level_discount_applications || []).reduce(function (a, x) { return a + (x.total_allocated_amount || 0); }, 0);
      var white = c.items.some(function (i) { return /white/i.test(i.variant_title || ''); }) && !c.items.some(function (i) { return /black/i.test(i.variant_title || ''); });
      if (c.item_count >= 3) {
        var anchor = d.querySelector('.wcd-ship') || head;
        if (!pack) { pack = document.createElement('div'); pack.className = 'wcd-pack'; anchor.insertAdjacentElement('afterend', pack); }
        pack.innerHTML = '<img src="' + (white ? IMG.w : IMG[1]) + '" alt=""><div><b>' + c.item_count + ' SlimCards bundle</b><span>' + ((PACKSAVE[c.item_count] && PACKSAVE[c.item_count][cur]) ? 'You save ' + money(PACKSAVE[c.item_count][cur], cur) + (c.item_count === 3 ? ' incl. free tracked shipping' : ' + free tracked shipping') : (saved > 0 ? 'You save ' + money(saved + (SHIPFEE[cur] || 0), cur) + ' incl. free tracked shipping' : 'Free tracked shipping')) + '</span></div>';
      } else if (pack) pack.remove();
      var foot = d.querySelector('.drawer__footer');
      if (foot && !foot.querySelector('.wcd-trust')) {
        var t = document.createElement('div'); t.className = 'wcd-trust';
        t.innerHTML = '<span>' + LOCK + 'Secure checkout</span><span>' + TRUCK + 'Tracked delivery</span><span>' + RET + '30-day returns</span>';
        foot.appendChild(t);
      }
      fixSym(d, cur);
      var btn = d.querySelector('#CartDrawer-Checkout');
      if (btn && !btn.dataset.wcd) { btn.dataset.wcd = '1'; btn.innerHTML = LOCK.replace('aria-hidden', 'style="width:18px;height:18px;margin-right:8px" aria-hidden') + 'Secure checkout'; }
    }).catch(function () {}).then(function () { setTimeout(function () { busy = false; }, 50); });
  }
  function start() {
    var d = document.querySelector('cart-drawer'); if (!d) return;
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    var t;
    new MutationObserver(function (m) {
      if (m.every(function (x) { return x.target.closest && x.target.closest('.wcd-ship,.wcd-pack,.wcd-trust,.wcd-count'); })) return;
      clearTimeout(t); t = setTimeout(paint, 120);
    }).observe(d, { childList: true, subtree: true });
    paint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Wherly : vidéos en boucle, sans son, lancées quand elles arrivent à l'écran et mises en pause hors écran (iPhone compris). */
(function () {
  function init() {
    var vids = [].slice.call(document.querySelectorAll('video[loop]'));
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (v.preload !== 'auto') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (v.muted) v.pause();
      });
    }, { rootMargin: '200px 0px', threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Wherly : icônes de paiement juste sous le bouton d'ajout au panier de la page produit. */
(function () {
  function placer() {
    var pay = document.querySelector('.product__info-container .w-pay2, .product .w-pay2'), form = document.querySelector('.product__info-container product-form, .product product-form');
    if (!pay || !form || form.nextElementSibling === pay) return;
    form.insertAdjacentElement('afterend', pay);
    pay.style.margin = '1.2rem 0 0';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placer); else placer();
})();
